import { InjectionToken } from '@angular/core';
import {
  SubmissionDetailState,
  SubmissionResponse,
} from '../types/submission.types';
import { SubmissionSitesListResponse } from '@data-access/sites';

export type SubmissionOrganizationStatus =
  | 'checking'
  | 'assigned'
  | 'unassigned';

export const SUBMISSION_DETAIL_INITIAL_STATE: SubmissionDetailState = {
  canCloseDialog: false,
  error: null,
  hasOutcomeDocuments: false,
  isLoading: false,
  submission: {} as SubmissionResponse,
  sites: {} as SubmissionSitesListResponse,
  appealSubmissionSetupPath: null,
  isSubmissionCancelled: false,
  organiationStatus: 'checking',
  organizationValidationAssignedTypes: [],
  organizationValidationUnassignedTypes: [],
  reloadContactOrgs: false,
};

export const SUBMISSION_DETAIL_INITIAL_STATE_TOKEN =
  new InjectionToken<SubmissionDetailState>('Submission Detail Initial State', {
    factory: () => ({ ...SUBMISSION_DETAIL_INITIAL_STATE }),
  });

export const SUBMISSION_DETAIL_ERRORS: Record<string, string> = {
  SUBMISSION_RESUBMISSION_ERROR:
    'We could not resubmit this submission. Please try again.',
};
